import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_STAFF = 'GET_STAFF';
export const GET_STAFF_SUCCESS = 'GET_STAFF_SUCCESS';
export const GET_STAFF_FAILURE = 'GET_STAFF_FAILURE';

// Action Creators
export const getStaff = () => ({
  type: GET_STAFF,
});

export const getStaffSuccess = (data) => ({
  type: GET_STAFF_SUCCESS,
  payload: data,
});

export const getStaffFailure = (error) => ({
  type: GET_STAFF_FAILURE,
  payload: error,
});

// Thunk Function
export const getStaffCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getStaff());
    try {
      const response = await getMethodWithToken(
        url.staff + data?.id + '/staff/' + data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getStaffSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getStaffFailure(error?.message));
    }
  };
};
